import React, { useEffect, useRef, useState } from "react";
import nav from "../images/benchmark/nav.png";
import hero from "../images/benchmark/hero.svg";
import what from "../images/benchmark/what.svg";
import when from "../images/benchmark/when.svg";
import bootcamp from "../images/benchmark/reg-bootcamp.svg";
import designathon from "../images/benchmark/reg-designathon.svg";

import gold from "../images/benchmark/gold.svg";
import silver from "../images/benchmark/silver.svg";
import bronze from "../images/benchmark/bronze.svg";

import eureka from "../images/benchmark/eureka.svg";
import brax from "../images/benchmark/brax.svg";
import nova from "../images/benchmark/nova.svg";

import whiteLogo from "../images/aiesec-white.png";
import logo from "../images/benchmark/logo.png";

import tagBG from "../images/benchmark/placeholder.png";

import { gsap } from "gsap";
import ReactGA from "react-ga";

const Benchmark = () => {
  const canvasRef = useRef(null);
  const [generatedImage, setImage] = useState(null);
  const [name, setName] = useState("");

  const styles = {
    blackbg: {
      backgroundColor: "#121212",
    },
    blueText: {
      color: "#037ef3",
    },
    gradient: {
      background:
        "linear-gradient(90deg, rgba(0,26,255,1) 0%, rgba(255,0,206,1) 100%)",
    },
    hidden: {
      visibility: "hidden",
    },
  };

  const downloadTag = () => {
    if (name) {
      ReactGA.event({
        category: "Delegate Tag",
        action: name,
        nonInteraction: true,
      });

      const canvas = canvasRef.current;
      const ctx = canvas.getContext("2d");

      ctx.clearRect(0, 0, canvas.width, canvas.height);

      var background = new Image();
      background.crossOrigin = "anonymous";
      background.src = tagBG;

      //ctx.fillText("Hello World", 10, 50);

      // Make sure the image is loaded first otherwise nothing will draw.
      background.onload = function () {
        ctx.drawImage(background, 0, 0);

        let [firstName, lastName] = name.split(" ", 2);

        // start with a large font size
        var fontsize = 95;

        // ==================================================
        do {
          fontsize--;
          ctx.font = fontsize + "px monospace";
        } while (ctx.measureText(firstName).width > 680);

        // draw the text
        ctx.fillStyle = "white";
        ctx.fillText(firstName, 208, 1030);

        // ====================================================
        fontsize = 95;
        do {
          fontsize--;
          ctx.font = fontsize + "px monospace";
        } while (ctx.measureText(lastName || "").width > 680);

        // draw the text
        ctx.fillStyle = "white";
        ctx.fillText(lastName || "", 208, 1130);

        // Generate the image
        let image = canvasRef.current.toDataURL("image/png");

        setImage(image);
      };
    } else {
      alert("Please enter a name");
    }
  };

  useEffect(() => {
    //ReactGA.pageview(window.location.pathname);

    gsap.fromTo(
      ".nav",
      {
        autoAlpha: 0,
        x: 300,
      },
      {
        autoAlpha: 1,
        x: 0,
        ease: "expo.out",
        duration: 2,
      }
    );

    gsap.fromTo(
      ".section",
      {
        autoAlpha: 0,
        y: 200,
      },
      {
        autoAlpha: 1,
        y: 0,
        ease: "expo.inOut",
        duration: 1.5,
        stagger: 0.05,
      }
    );
  }, []);

  return (
    <div
      className="w-full min-h-screen text-white py-4 px-4 overflow-hidden"
      style={styles.blackbg}
    >
      <div className="nav" style={styles.hidden}>
        <img src={nav} alt="nav bar" />
      </div>

      <div className="flex justify-end p-8 section" style={styles.hidden}>
        <img className="w-full max-w-xl pl-10 my-28" src={hero} alt="hero" />
      </div>

      <div className="w-full m-auto flex flex-wrap items-center justify-center">
        <div className="w-full max-w-xs p-5 section " style={styles.hidden}>
          <img
            className="transform hover:scale-110 transition-all"
            src={what}
            alt="card"
          />
        </div>
        <div className="w-full max-w-xs p-5 section" style={styles.hidden}>
          <img
            className="transform hover:scale-110 transition-all"
            src={when}
            alt="card"
          />
        </div>
        <div
          className="w-full max-w-xs p-5 section cursor-pointer"
          style={styles.hidden}
        >
          <a
            href="https://tripetto.app/run/QIPX7XOCP1"
            target="_blank"
            rel="noreferrer"
          >
            <img
              className="transform hover:scale-110 transition-all"
              src={bootcamp}
              alt="card"
            />
          </a>
        </div>
        <div
          className="w-full max-w-xs p-5 section cursor-pointer"
          style={styles.hidden}
        >
          <a
            href="https://tripetto.app/run/FSXURZSTPQ"
            target="_blank"
            rel="noreferrer"
          >
            <img
              className="transform hover:scale-110 transition-all"
              src={designathon}
              alt="card"
            />
          </a>
        </div>
      </div>

      <div
        className="w-full flex justify-center section mt-12"
        style={styles.hidden}
      >
        <a
          href="https://drive.google.com/file/d/1FiEnaYWe7GNEWWIxrwM-cizi7qxZpNAs/view"
          target="_blank"
          rel="noreferrer"
        >
          <div
            style={styles.gradient}
            className="text-2xl py-3 px-12 cursor-pointer rounded-3xl"
          >
            Event Booklet
          </div>
        </a>
      </div>

      <div
        className="mt-20 text-center section"
        style={styles.hidden}
        id="tags"
      >
        <div
          className="font-mono mt-12 text-4xl md:text-5xl lg:text-7xl w-full text-center font-bold"
          style={{ color: "#ababab" }}
        >
          Tags
        </div>

        <div style={{ display: "none" }}>
          <canvas ref={canvasRef} width="1080" height="1920" />
        </div>

        <input
          onChange={(e) => setName(e.target.value)}
          placeholder="Enter First Name and Last Name"
          className="w-full mt-6 border-blue border-2 rounded-lg max-w-sm p-4 bg-black text-white"
        />
        <br />

        <button
          onClick={downloadTag}
          style={styles.gradient}
          className="text-2xl my-6 py-3 px-12 cursor-pointer rounded-3xl"
        >
          Generate Tag
        </button>

        {generatedImage && (
          <div className="w-full max-w-sm m-auto">
            <img className="w-full" alt="generated" src={generatedImage} />
            <div className="opacity-30">Right-click &gt; Save Image As..</div>
            <div className="text-lg mt-4 font-mono">
              Download your tag and share it on social media! Don't forget to
              tag @aiesecsrilanka
            </div>
          </div>
        )}
      </div>

      <div
        className="font-mono mt-20 md:mt-20 text-5xl md:text-6xl lg:text-8xl w-full text-center section"
        style={styles.hidden}
      >
        Prizes
      </div>
      <div className="w-full m-auto flex flex-wrap items-center justify-center">
        <div
          className="w-full max-w-xs px-5 section my-4"
          style={styles.hidden}
        >
          <img src={gold} alt="card" />
        </div>
        <div
          className="w-full max-w-xs px-6 section my-4"
          style={styles.hidden}
        >
          <img src={silver} alt="card" />
        </div>
        <div
          className="w-full max-w-xs px-7 section my-4"
          style={styles.hidden}
        >
          <img src={bronze} alt="card" />
        </div>
      </div>

      <div className="section" style={styles.hidden}>
        <div className="font-mono mt-20 md:mt-20 text-5xl md:text-6xl lg:text-8xl w-full text-center">
          Our Partners
        </div>

        <div
          className="font-mono mt-16 text-4xl md:text-5xl lg:text-7xl w-full text-center font-bold"
          style={{ color: "#ababab" }}
        >
          Platinum Partner
        </div>

        <div className="w-full m-auto flex flex-wrap items-center justify-center">
          <div className="w-full max-w-xs px-12 my-9 ">
            <img src={eureka} alt="card" />
          </div>
        </div>

        {/* Ad partners */}
        <div
          className="font-mono mt-12 text-4xl md:text-5xl lg:text-7xl w-full text-center font-bold"
          style={{ color: "#ababab" }}
        >
          Advertisement Partners
        </div>

        <div className="w-full m-auto flex flex-wrap items-center justify-center">
          <div className="w-full max-w-xs px-20 my-9 ">
            <img src={brax} alt="card" />
          </div>

          <div className="w-full max-w-xs px-20 my-9 ">
            <img src={nova} alt="card" />
          </div>
        </div>

        <div className="container m-auto flex flex-col md:flex-row mt-20 gap-20">
          <div className="w-full md:w-2/4">
            <img className="w-full max-w-xs" src={whiteLogo} alt="logo" />
            <div className="pl-4 mt-7">
              AIESEC in SLIIT is a local chapter of AIESEC Sri Lanka, a
              non-governmental not-for-profit organization.AIESEC is a global
              youth-led organization striving to achieve peace and fulfillment
              of humankind’s potential by activating leadership qualities in
              youth through learning from practical experiences in challenging
              environments. Together with partner organizations, AIESEC
              facilitates a network of cross-cultural exchanges in the form of
              volunteering experiences and professional internships.​
            </div>
          </div>

          <div className="w-1/2">
            <img className="w-full max-w-xs -mt-12" src={logo} alt="logo" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Benchmark;
